import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/index'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Index',
    redirect: '/home',
    component: Index,
    children: [
      {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/home/index')
      },
      {
        path: '/list',
        name: 'List',
        component: () => import('@/views/list/index')
      },
      {
        path: '/detail',
        name: 'Detail',
        component: () => import('@/views/detail/index')
      }
    ]
  },
  {
    path: '/appsearch',
    name: 'Appsearch',
    component: () => import('@/views/app/index')
  },
  {
    path: '/appsearchdetail',
    name: 'Appsearchdetail',
    component: () => import('@/views/app/appsearchdetail')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index')
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

router.beforeEach((to, from, next) => {
  var sUserAgent = navigator.userAgent.toLowerCase()
  if (/ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)) {
    if (to.path === '/detail') {
      next({path: '/appsearchdetail', query: to.query})
    } else if (to.path === '/list' || to.path === '/home') {
      next({path: '/appsearch', query: to.query})
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
